import { FormatListBulletedRounded, ViewKanbanRounded } from '@mui/icons-material';

import type { TeamTaskBucket } from '../../../data-access';
import type { ProjectFilterItem } from '../../../hooks';
import type { TeamTasksGroupBy } from '../utils';
import type { TeamTasksFilterOption, TeamTasksGroupOption, TeamTasksLayout } from './types';

export const TEAM_FILTER_OPTIONS: TeamTasksFilterOption[] = [
  { value: 'all' },
  { value: 'mine' },
  { value: 'overdue', bucket: 'overdue' },
  { value: 'today', bucket: 'today' },
  { value: 'upcoming', bucket: 'upcoming' },
  { value: 'done', bucket: 'done' },
];

export const SHARED_FILTER_OPTIONS: TeamTasksFilterOption[] = [
  { value: 'all' },
  { value: 'overdue', bucket: 'overdue' },
  { value: 'today', bucket: 'today' },
  { value: 'upcoming', bucket: 'upcoming' },
  { value: 'done', bucket: 'done' },
];

export const GROUP_OPTIONS: TeamTasksGroupOption[] = [
  { value: 'due' },
  { value: 'member' },
  { value: 'board' },
];

export const GROUP_SHORTCUTS: Record<TeamTasksGroupBy, string> = {
  due: 'D',
  member: 'M',
  board: 'P',
};

export const LAYOUT_OPTIONS: Array<{
  value: TeamTasksLayout;
  icon: typeof FormatListBulletedRounded;
}> = [
  { value: 'list', icon: FormatListBulletedRounded },
  { value: 'kanban', icon: ViewKanbanRounded },
];

export const TEAM_TASKS_SEGMENT_STORAGE_KEY = 'team-tasks-segment';
export const TEAM_TASKS_GROUP_BY_STORAGE_KEY = 'team-tasks-group-by';
export const TEAM_TASKS_LAYOUT_STORAGE_KEY = 'team-tasks-layout';
export const TEAM_TASKS_BOARD_FILTER_STORAGE_KEY = 'team-tasks-board-filter';

export const BOARD_FILTER_ALL = 'all';

export const ALL_PROJECT_FILTER: ProjectFilterItem = {
  todoTaskId: BOARD_FILTER_ALL,
  name: '',
  appFrom: 'all',
};

export const BUCKET_CLASS_NAMES: Record<TeamTaskBucket, string> = {
  overdue: 'team-tasks-view__bucket-dot--overdue',
  today: 'team-tasks-view__bucket-dot--today',
  upcoming: 'team-tasks-view__bucket-dot--upcoming',
  done: 'team-tasks-view__bucket-dot--done',
};

export const BUCKET_COLORS: Record<TeamTaskBucket, string> = {
  overdue: 'var(--color-red-base, #f34720)',
  today: 'var(--color-primary, #680ddb)',
  upcoming: 'var(--color-gray-dark, #7c7c7c)',
  done: 'var(--color-green-base, #09c25a)',
};
